<template lang="pug">
  b-container(fluid)
    b-form-row.mb-2.align-items-center
      b-col
        h5.mb-0 Mensajes para cuando el chatbot no tiene respuesta
      // uncomment this after backend fix bug
      //b-form-checkbox(switch, :checked="enable", @change="updateBlock({enable: $event})") {{enable ? 'Activada' : 'Desactivada'}}
      b-col(cols="auto")
        b-button(variant="primary", size="sm", @click="createResponse", :disabled="loading") Agregar respuesta
    .mb-2(v-for="(response, index) in responses", :key="index")
      b-input-group.mb-2
        b-form-textarea(placeholder="Respuesta", v-model="response.value", @input="updateResponse(response)")
        b-input-group-append
          b-button(:variant="response.loading ? 'soft-secondary' : 'soft-danger'", @click="destroyResponse(response, index)", :disabled="response.loading")
            b-spinner(small, variant="primary", v-if="response.loading")
            trash-2-icon.icon-sm(v-else)
      div.px-3.d-flex.align-items-center
        corner-down-right-icon.icon-sm.mr-3
        b-link.text-sm(@click="response_index = index; $refs.answer_file_input.click()") Adjuntar archivo o imagen
      div.mt-2.d-flex.flex-wrap(style="padding-left:48px;")
        b-card.mb-1.mr-1.px-1.py-2.bg-light(no-body, v-for="(media, media_index) in response.media", :key="media_index")
          .d-flex.align-items-center.my-auto
            b-img.mr-2(v-if="media.type === 'image'", width="30", height="30", :src="media.url")
            span.mr-2.text-secondary.text-sm {{ getFileExt(media.url) }}
            x-icon.icon-sm.text-danger.pointer(@click="removeMedia(response, media_index)")
    .text-right
      b-button(variant="primary", size="sm", @click="createAction", :disabled="loading", v-if="!has_next_block") Conectar a bloque
    div(v-for="(action, index) in actions", :key="`action_${index}`", v-if="action.type === 'next_block'")
      block-connector(:next_block_id="action.payload.next_block_id", @change="updateAction(action, $event)")
      b-link.text-danger.text-sm(@click="destroyAction(action, index)") Quitar conexión
    input.d-none(type="file", accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv", ref="answer_file_input", @change="fileSelected")
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
import _debounce from "lodash.debounce";
import {UploadFile} from "../helpers/upload-file";

export default {
  data () {
    return {
      loading: false,
      response_index: null,
    }
  },
  props: {
    id: {
      default: null
    },
    enable: {
      type: Boolean,
      default: true
    },
    responses: {
      type: Array,
      default: function () {
        return [];
      }
    },
    actions: {
      type: Array,
      default: function () {
        return [];
      }
    },
  },
  computed: {
    has_next_block () {
      return !!this.actions.find(el => el.type === 'next_block')
    },
  },
  methods: {
    ...mapActions(['response_block/update', 'response_block/create_response', 'response_block/update_response', 'response_block/destroy_response', 'response_block/create_action', 'response_block/update_action', 'response_block/destroy_action', 'helpers/upload_file']),
    updateBlock (data) {
      this.loading = true
      let self = this

      this['response_block/update']({
        account_id: self.$route.params.account_id,
        response_block_id: self.id,
        ...data,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Configuración actualizada')
          }
        }
      })
    },
    createResponse () {
      this.loading = true
      let self = this

      this['response_block/create_response']({
        account_id: self.$route.params.account_id,
        response_block_id: self.id,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.responses.push(res.resource)
          }
        }
      })
    },
    updateResponse: _debounce(function (response) {
      let self = this
      response.loading = true

      this['response_block/update_response']({
        account_id: self.$route.params.account_id,
        response_block_id: self.id,
        ...response,
        callback: res => {
          response.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Respuesta actualizada')
          }
        }
      })
    }, 1000, {leading: false, trailing: true}),
    destroyResponse (response, index) {
      let self = this
      response.loading = true

      this['response_block/destroy_response']({
        account_id: self.$route.params.account_id,
        response_block_id: self.id,
        ...response,
        callback: res => {
          response.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.responses.splice(index, 1)
          }
        }
      })
    },
    async fileSelected (event) {
      let files = event.target.files
      let file = files[0]

      if(file) {
        if(file.size / 1000000 >= 25) {
          this.$message.warning('El archivo no debe exceder los 25 megabytes')
        } else {
          let response = this.responses[this.response_index]
          response.loading = true
          let media = {
            type: file.type.match(/image/gmi) ? 'image' : 'file',
            url: ''
          }
          try {
            media.url = await UploadFile.call(this, file)
            response.media.push(media)
            this.updateResponse(response)
          } catch (e) {
            this.$message.warning('No logramos subir la imagen, por favor comprueba tu conexión a internet')
          }
          response.loading = false
        }
      }
    },
    getFileExt (url) {
      try {
        return url.split('/').slice(-1)[0]
      } catch (e) {
        return url
      }
    },
    removeMedia (response, media_index) {
      response.media.splice(media_index, 1)
      this.updateResponse(response)
    },
    createAction () {
      this.loading = true
      let self = this

      this['response_block/create_action']({
        account_id: self.$route.params.account_id,
        response_block_id: self.id,
        type: 'next_block',
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.actions.push(res.resource)
          }
        }
      })
    },
    updateAction (action, data) {
      let self = this
      action.payload.next_block_id = data.next_block_id
      this['response_block/update_action']({
        account_id: self.$route.params.account_id,
        response_block_id: self.id,
        ...action,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Conexión actualizada')
          }
        }
      })
    },
    destroyAction (action, index) {
      let self = this

      this['response_block/destroy_action']({
        account_id: self.$route.params.account_id,
        response_block_id: self.id,
        ...action,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.actions.splice(index, 1)
          }
        }
      })
    },
  },
  mounted () {

  }
}
</script>

<style lang="scss" scoped>
</style>
